<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row class="ml-0 mt-3 mr-3">
          <v-chip :color="ui.chipColor" :class="ui.textSubheadingBold">
            Operations Notification
          </v-chip>
          <v-spacer/>
          <v-chip :color="ui.chipColor" :class="ui.textSubheading"
          v-if="!this.opsStatus && !this.opsArchived">
            <v-icon :color="ui.btnColorWarning">done</v-icon>
          </v-chip>
          <v-chip :color="ui.chipColor" :class="ui.textSubheading"
          v-if="this.opsArchived">
            <v-icon :color="ui.btnColorWarning">archive</v-icon>
          </v-chip>
          <v-chip :color="ui.chipColor" :class="ui.textSubheading">
            <v-icon left :color="ui.btnColor">thumb_up</v-icon>
            {{getDetailStats.nlike}}
          </v-chip>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="type"
              :label="this.localForm.type"
              :items="opsNotificationType"
              color="wplblue0"
              prepend-icon="grid_view"
              hint="operations notification type"
              persistent-hint
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="orgTheme"
              :label="this.localForm.orgTheme"
              :items="opsNotificationOrigin"
              color="wplblue0"
              prepend-icon="adjust"
              hint="orgin theme"
              persistent-hint
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="dis"
              :label="this.localForm.dis"
              :items="engineeringDiscipline"
              color="wplblue0"
              prepend-icon="engineering"
              hint="discipline"
              persistent-hint
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-3 mr-2 mt-4">
          <v-flex xs12>
            <v-textarea
            :change="updateFormChar()"
            :color="ui.textColor"
            :background-color="ui.btnColor"
            v-model="localForm.des"
            label="Operations Observation"
            :disabled="false"
            :outline="true"
            :rules="ruleMustBeNotUndefinedANDLessThan2000"
            hint="reported event, or noted experience"
            auto-grow
            persistent-hint
            ></v-textarea>
          </v-flex>
        </v-layout>
        <v-layout wrap row align-right justify-end fill-height class="mt-4 ml-1">
          <v-spacer/>
          <WorkRequestNew :data="{btnTitle: 'New Work Request'}"
          v-if="this.opsStatus"/>
          <v-btn :disabled="!this.enableConfirm || !this.opsStatus"
          :color="ui.btnColor" flat dark @click="confirmNotification()">
            <v-icon left>
              thumb_up
            </v-icon>
            Confirm
          </v-btn>
        </v-layout>
        <v-layout wrap row align-right justify-end fill-height class="mt-4 ml-1">
          <v-spacer/>
          <v-btn :disabled="!this.opsStatus"
          :color="ui.btnColor" flat dark @click="archiveOpsNotification()">
            <v-icon left>
              done
            </v-icon>
            Complete Ops Noti
          </v-btn>
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import opsOptions from "@/data/options/mixins/opsOptions.js";
import techOptions from "@/data/options/mixins/techOptions.js";
import WorkRequestNew from "@/work/request/components/WorkRequestNew";
import announcements from "@/frame/messages/mixins/announcements.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      enableConfirm: true,
      completeNotiBtnPressed: false,
      localForm: {
        des: "",
        dis: "",
        orgTheme: "",
        type: "",
        stat: false
      },
      orgForm: {
        des: "",
        dis: "",
        orgTheme: "",
        type: "",
        stat: false
      },
      type: "",
      dis: "",
      orgTheme: ""
    };
  },
  components: {
    WorkRequestNew
  },
  watch: {
    // whenever question changes, this function will run
    type() {
      this.localForm.type = this.type;
      this.updateFormChar();
    },
    orgTheme() {
      this.localForm.orgTheme = this.orgTheme;
      this.updateFormChar();
    },
    dis() {
      this.localForm.dis = this.dis;
      this.updateFormChar();
    }
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.type = this.getDetail.char.type;
    this.localForm.des = this.getDetail.char.des;
    this.localForm.dis = this.getDetail.char.dis;
    this.localForm.orgTheme = this.getDetail.char.org;
    this.localForm.stat = this.getDetail.char.stat;

    this.orgForm.type = this.getDetail.char.type;
    this.orgForm.des = this.getDetail.char.des;
    this.orgForm.orgTheme = this.getDetail.char.org;
    this.orgForm.dis = this.getDetail.char.dis;
    this.orgForm.stat = this.getDetail.char.stat;
  },
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    opsOptions,
    techOptions,
    announcements
  ],
  computed: {
    ...mapGetters([
      "getDetail",
      "getDetailBasic",
      "getDetailChar",
      "getDetailStats"
    ]),
    opsStatus() {
      let logic;
      if (this.getDetailChar.stat === true || this.completeNotiBtnPressed) {
        logic = false;
      } else {
        logic = true;
      }
      return logic;
    },
    opsArchived() {
      let logic;
      if (this.getDetailBasic.ver === "A") {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    }
  },
  methods: {
    confirmNotification() {
      let stats = this.getDetailStats;
      stats.nlike = stats.nlike + 1;
      // lock the button (one confirm at a time)
      this.enableConfirm = false;
      this.saveDocumentRevMod(4.11, 9); // business mod.
      this.$store.dispatch("changeDetailStats", stats);
      this.$store.dispatch("changeDataSavePendingIndication", true);
    },
    archiveOpsNotification() {
      this.completeNotiBtnPressed = true;
      this.localForm.stat = true;
      // MESSAGE
      let msg = "";
      msg = "Ops Noti complete process started.";
      this.generateInfoSnackbar(this.ui.colorWarning, msg);
    },
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line
      if (
        this.localForm.type !== this.orgForm.type &&
        this.localForm.type !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.type = this.localForm.type;
        // basic
        char.type = this.localForm.type;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.12, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.des !== this.orgForm.des &&
        this.localForm.des !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.des = this.localForm.des;
        // basic
        char.des = this.localForm.des;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.11, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.dis !== this.orgForm.dis &&
        this.localForm.dis !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.dis = this.localForm.dis;
        // basic
        char.dis = this.localForm.dis;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.11, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.orgTheme !== this.orgForm.orgTheme &&
        this.localForm.orgTheme !== ""
      ) {
        console.log("ORG THEME");
        console.log(this.localForm.orgTheme);
        console.log(this.orgForm.orgTheme);
        // after the change re-assign new Local to Org
        this.orgForm.orgTheme = this.localForm.orgTheme;
        // basic
        char.org = this.localForm.orgTheme;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.11, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (this.localForm.stat !== this.orgForm.stat) {
        // after the change re-assign new Local to Org
        this.orgForm.stat = this.localForm.stat;
        // basic
        char.stat = this.localForm.stat;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.11, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
